import React from 'react';
import { Title, Grid, GridItem, Icon } from '@landing/ui';
import { Container } from 'components/UI';
import { Card } from 'components/cards';
import * as styles from './Benefits.module.scss';

export default function Benefits({
  id,
  title,
  bgColor,
  items = [],
  padding = 'Without',
  onItemClick,
  partners,
  ...rest
}) {
  const gridSettings = {
    xsm: { cols: 1, gutterX: '20px', gutterY: '40px' },
    sm: { cols: 2, gutterX: '20px', gutterY: '40px' },
    md: { cols: 2, gutterX: '40px', gutterY: '40px' },
    lg: { cols: 2, gutterX: '40px', gutterY: '60px' },
    xl: { cols: 2, gutterX: '40px', gutterY: '60px' },
  };

  return (
    <Container
      id={id}
      theme="outer"
      background="lightGray"
      padding={padding}
      className={styles.container}
    >
      <Container theme="inner">
        <div className={styles.layout}>
          <Title tag="h2">{title}</Title>
          <div className={styles.gridWrapper}>
            <Grid {...gridSettings}>
              {items.map(item => (
                <GridItem key={item.title}>
                  <Card
                    onClick={onItemClick ? () => onItemClick(item) : null}
                    {...item}
                    {...rest}
                  />
                </GridItem>
              ))}
            </Grid>
          </div>
          {partners && (
            <div className={styles.partners}>
              <Title tag="h3" className={styles.partnerTitle}>
                {partners.title}
              </Title>
              <div className={styles.icons}>
                {partners?.iconList.map(item => (
                  <Icon key={item} name={item} className={styles.icon} />
                ))}
              </div>
            </div>
          )}
        </div>
      </Container>
    </Container>
  );
}
